module.exports = __webpack_public_path__ + "static/media/mockup2.1f8cbda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/mockup2.png
// module id = 894
// module chunks = 0